export default __webpack_public_path__ + "f72c5533c9942c4f595a034d3cf12ce9.mp3";